import { combineAiDataSources } from "../hooks/summarySnapshot.mjs";
import React, { useMemo } from "react"
import { useSummaryData } from "../hooks/useSummaryData"
import { ClassName_EUIRollingCostsCharts } from "./summaryChartClassnames"
import { EUIRollingCostsBaseChart } from "@/components/base-chart/EUIRollingCostsBaseChart/EUIRollingCostsBaseChart"

export const config = {
  title: 'Monthly Electricity and Gas Costs',
}

export const EUIRollingCostsCharts = ({
  period,
  endingMonth,
  disableTooltip = false
}) => {

  const electricitySource = useSummaryData("electricity", period, endingMonth);
  const { data: electricityData = { electricity: [] } } = electricitySource;
  const gasSource = useSummaryData("gas", period, endingMonth);
  const { data: gasData = { gas: [] } } = gasSource;

  return (
    <EUIRollingCostsBaseChart
      electricityData={electricityData.electricity}
      gasData={gasData.gas}
      title={config.title}
      className={ClassName_EUIRollingCostsCharts}
      style={{ width: '100%', height: '100%' }}
      customOptions={disableTooltip ? { tooltip: { show: false } } : {}}
      aiContext={{
        pageId: "page.facility.utility.summary",
          ...combineAiDataSources(electricitySource, gasSource),
        chart: {
          chartId: "utility.combined.monthly_cost",
          title: config.title,
          aliases: ["combined utility costs", "monthly electricity and gas cost", "水电气成本图", "月度电力和燃气成本"],
          chartType: "stacked_bar",
          description: "Monthly electricity and gas costs shown as stacked bars.",
          filters: { period, ending_month: endingMonth },
          sourceOperationIds: ["utility.monthly_cost"],
          series: [
            {
              name: "Electricity Costs",
              unit: "USD",
              points: electricityData.electricity.map((item) => ({ label: item.month, value: item.costs })),
            },
            {
              name: "Gas Costs",
              unit: "USD",
              points: gasData.gas.map((item) => ({ label: item.month, value: item.costs })),
            },
          ],
          completeness: electricityData.electricity.length && gasData.gas.length ? "complete" : "partial",
        },
      }}
    />
  )
}
